import { useEffect, useState } from "react";
import { Gift, Copy, Share2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function InviteCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/referral/me").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return null;
  const link = `${window.location.origin}/?ref=${d.code}`;
  const pct = Math.min(100, (d.earned_eur / d.cap_eur) * 100);

  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success("Link copiato"); } catch { toast.error("Copia non riuscita"); }
  };
  const share = async () => {
    if (!navigator.share) return copy();
    try { await navigator.share({ title: "Coach2Go", text: "Ti consiglio Coach2Go, il coaching quotidiano che uso io:", url: link }); } catch { /* annullato */ }
  };

  return (
    <div className="mt-5 rounded-2xl border border-[#D4AF37]/40 bg-[#D4AF37]/5 p-5" data-testid="invite-card">
      <p className="flex items-center gap-2 text-base font-semibold text-[#F4F4F5]"><Gift size={17} className="text-[#D4AF37]" /> Invita un amico</p>
      <p className="mt-2 text-sm leading-relaxed text-[#B4B4BC]">
        Per ogni amico che si iscrive dal tuo link e paga il <b className="text-[#E5C158]">piano annuale</b> ricevi <b className="text-[#E5C158]">{d.reward_eur} € di sconto</b> sul tuo prossimo rinnovo, fino a {d.cap_eur} €. Lo sconto scatta dopo il primo pagamento dell'amico, cioè al termine della prova gratuita.
      </p>
      <div className="mt-3 flex items-center gap-2 rounded-xl border border-[#27272A] bg-[#0D0D0F] p-2 pl-3">
        <span className="flex-1 truncate text-sm text-[#E4E4E7]" data-testid="invite-link">{link}</span>
        <button onClick={copy} data-testid="invite-copy" className="rounded-lg border border-[#3F3F46] p-2 text-[#E4E4E7]" aria-label="Copia link"><Copy size={15} /></button>
        <button onClick={share} data-testid="invite-share" className="rounded-lg bg-[#D4AF37] p-2 text-[#09090B]" aria-label="Condividi link"><Share2 size={15} /></button>
      </div>
      <div className="mt-4 flex justify-between text-sm text-[#B4B4BC]">
        <span data-testid="invite-invited">Iscritti dal tuo link: <b className="text-[#F4F4F5]">{d.invited}</b></span>
        <span data-testid="invite-earned">Sconti: <b className="text-[#F4F4F5]">{d.earned_eur} € / {d.cap_eur} €</b></span>
      </div>
      <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-[#27272A]"><div className="h-full bg-[#D4AF37]" style={{ width: `${pct}%` }} /></div>
      {d.rewards.length > 0 && (
        <ul className="mt-3 space-y-1 text-[13px] text-[#8A8E96]" data-testid="invite-rewards">
          {d.rewards.map((r, i) => <li key={i}>{r.friend} · {r.amount_eur} € · {r.status_label}</li>)}
        </ul>
      )}
    </div>
  );
}
